/**
 * As quatro perguntas da escala HRN. Rótulos e opções vêm da escala do servidor.
 */
import React from 'react';
import { Grid, MenuItem, TextField } from '@mui/material';
import type { HrnScale } from '../../../../types/machine';
import { HRN_FACTOR_KEYS, formatHrnNumber, type HrnAnswers } from './hrnCalculation';

interface HrnFactorFieldsProps {
  scale: HrnScale;
  answers: HrnAnswers;
  onChange: (answers: HrnAnswers) => void;
  /** Prefixo do id, para o bloco "após adequações" não repetir os do bloco "hoje". */
  idPrefix: string;
  /** Mostra a opção que desfaz a resposta (bloco opcional). */
  allowClear?: boolean;
  /** Sufixo do rótulo acessível que diferencia os dois blocos. */
  labelSuffix?: string;
}

export const HrnFactorFields: React.FC<HrnFactorFieldsProps> = ({
  scale,
  answers,
  onChange,
  idPrefix,
  allowClear = false,
  labelSuffix = '',
}) => (
  <Grid container spacing={2}>
    {HRN_FACTOR_KEYS.map((key) => {
      const factor = scale.factors.find((item) => item.key === key);
      if (!factor) return null;
      const current = answers[key];
      return (
        <Grid key={key} size={{ xs: 12, sm: 6 }}>
          <TextField
            select
            fullWidth
            id={`${idPrefix}-${key}`}
            label={`${factor.label}${labelSuffix}`}
            value={current === '' ? '' : String(current)}
            onChange={(event) =>
              onChange({ ...answers, [key]: event.target.value === '' ? '' : Number(event.target.value) })
            }
          >
            {allowClear && (
              <MenuItem value="" sx={{ minHeight: 44 }}>
                Não informar
              </MenuItem>
            )}
            {factor.options.map(({ value, label }) => (
              <MenuItem key={value} value={String(value)} sx={{ minHeight: 44 }}>
                {`${formatHrnNumber(value)} — ${label}`}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      );
    })}
  </Grid>
);

export default HrnFactorFields;
